"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var RangeBar = /** @class */ (function (_super) {
    tslib_1.__extends(RangeBar, _super);
    function RangeBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RangeBar.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'rangeBar';
        _super.prototype.createLayers.call(this, layerProps);
    };
    RangeBar.getDefaultOptions = layer_1.default.getDefaultOptions;
    return RangeBar;
}(plot_1.default));
exports.default = RangeBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/range-bar/index.js
// module id = 956
// module chunks = 37